module.exports = __webpack_public_path__ + "img/icon_arrow_up.b4aad092.svg";